export const createDashboardService = (http, baseUrl) => {
  const buildURL = (path, params = {}) => {
    const query = new URLSearchParams(params).toString()
    if (query) {
      return `${baseUrl}${path}?${query}`
    }
    return `${baseUrl}${path}`
  }

  return {
    getDashboard () {
      return http.get(buildURL('/user/dashboard'))
    },

    getNeedsPractice (limit = 10) {
      return http.get(buildURL('/user/dashboard/needs-practice', { limit }))
    }
  }
}
